import type { OrderLine } from "~/@types/orderLines";

import { FulfillmentSource } from "~/gql/graphqlBase.generated";
import i18n from "~/i18n/i18n";

export { FulfillmentSource };

const tf = (key: string): string => i18n.t(key, { ns: "fulfill" });

export const fulfillmentSourceLabel = (source: FulfillmentSource): string =>
	source === FulfillmentSource.MakeToOrder
		? tf("orders.fulfillmentSource.growIt")
		: tf("orders.fulfillmentSource.fromStock");

export const fulfillmentSourceGroupLabel = (): string => tf("orders.fulfillmentSource.groupLabel");

export const DEFAULT_FULFILLMENT_SOURCE = FulfillmentSource.ExistingStock;

export const lineItemFulfillmentSource = (
	line: { fulfillmentSource?: OrderLine["fulfillmentSource"] | null } | null | undefined
): FulfillmentSource =>
	line?.fulfillmentSource && line.fulfillmentSource !== FulfillmentSource.Unspecified
		? line.fulfillmentSource
		: DEFAULT_FULFILLMENT_SOURCE;

// wsapi has no field to persist a fulfillmentSource change on an existing line, so a locked toggle needs its own explanation distinct from a generally read-only order.
export const fulfillmentSourceLockedTooltip = (isPersistedRow: boolean, isGloballyReadOnly: boolean): string =>
	isPersistedRow && !isGloballyReadOnly ? tf("orders.fulfillmentSource.lockedTooltip") : "";
